import {
  MobileRequestApprovalWaitTable,
  WebRequestApprovalWaitTable,
} from "components";
import React from "react";
import { View } from "react-native";
import { RequestList, UserCollection } from "types";
import { IsWeb } from "utils";

export const RequestApprovalWaitTable = ({
  tableList,
  onEditClick,
  UserCollection,
}: {
  tableList: RequestList[] | null;
  onEditClick: (id: string) => void;
  UserCollection: UserCollection[];
}) => {
  return (
    <>
      {tableList === null ? (
        <View></View>
      ) : IsWeb() ? (
        <WebRequestApprovalWaitTable
          onEditClick={onEditClick}
          tableList={tableList}
          UserCollection={UserCollection}
        />
      ) : (
        <MobileRequestApprovalWaitTable
          onEditClick={onEditClick}
          tableList={tableList}
          UserCollection={UserCollection}
        />
      )}
    </>
  );
};
